<template>
	<div class="container">
		<breadcrumbs
			class="ar"
			:links="[
				{ name: $t('links.home'), link: { name: 'home' } },
				{ name: $t('links.about'), link: { name: 'about-us' }, active: true },
			]"></breadcrumbs>
		<div class="top">
			<div class="title">{{ $t('links.about') }}</div>
		</div>

		<div class="main">
			<loader v-if="loading" height="45vh" class="mb-4" />
			<div v-else>
				<div class="image">
					<img src="/assets/CompanyLogo/logo.png" alt="" />
				</div>
				<div class="sub-title">{{ $t('about.message') }}</div>
				<div class="vision ck-content" v-html="aboutUs.find((c) => c.Key === 'mission').Value"></div>

				<div class="sub-title">{{ $t('about.gaol') }}</div>
				<div
					class="found ar text-end ck-content"
					v-html="aboutUs.find((c) => c.Key === 'foundation').Value"></div>

				<div class="sub-title">{{ $t('about.about') }}</div>
				<div class="found ar text-end ck-content" v-html="aboutUs.find((c) => c.Key === 'goal').Value"></div>

				<loader v-if="loadingSeriesAndVolumes" height="90px" class="mb-4" />
				<div v-else>
					<div class="sub-title">ISSN</div>
					<div class="found ar text-end">
						<div class="issn-container">
							<div class="issn-header">
								<div class="issn-item">{{ $t('series') }}</div>
								<div class="issn-item">ISSN</div>
							</div>
							<div class="issn-body" v-for="serie in series" :key="serie">
								<div class="issn-item">{{ serie.name }}</div>
								<div class="issn-item">{{ serie.issn }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="main">
			<div class="sub-title">{{ $t('series') }}</div>
			<loader v-if="loadingSeriesAndVolumes" height="45vh" class="mb-4" />
			<div class="series" v-else>
				<series-card v-for="serie in series" :key="serie" :serie="serie"></series-card>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import SeriesCard from '@/components/SeriesCard';
import Loader from '@/components/Loader';
import { mapState } from 'vuex';
export default {
	props: ['loadingSeriesAndVolumes'],

	data() {
		return {
			loading: true,
		};
	},

	components: {
		Breadcrumbs,
		SeriesCard,
		Loader,
	},

	computed: {
		...mapState({
			series: (state) => state.series.series,
			aboutUs: (state) => state.aboutUs.aboutUs,
		}),
	},

	mounted() {
		this.$store.dispatch('aboutUs/fetchAll').then(() => {
			this.loading = false;
		});
	},
};
</script>

<style scoped>
.container {
	margin: 50px 0;
}
.container > * {
	margin: 0 50px;
}
.top {
	text-align: center;
	padding: 10px 0 30px;
	border-bottom: 2px solid var(--borders-color);
}
.top > * {
	padding: 10px;
}
.title {
	font-size: 36px;
	font-family: changeBold;
	color: var(--green-color);
}
.sub-title {
	color: var(--green-color);
	font-size: 24px;
	font-family: changeBold;
	text-align: center;
	margin: 35px 0 10px;
}
.main {
	padding: 0 50px;
}
.image {
	width: max-content;
	margin: 30px auto;
}
.vision,
.found {
	white-space: pre-line;
	text-align: center;
	font-size: 18px;
	font-family: changeMedium;
}
.series {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	row-gap: 20px;
	column-gap: 10%;
}
.issn-container {
	max-width: 900px;
	margin: auto;
}

.issn-container .issn-header,
.issn-container .issn-body {
	display: grid;
	grid-template-columns: 60% 40%;
}
.issn-item {
	border: 1px solid #666;
	border-collapse: collapse;
	padding: 5px;
	text-align: center;
}
.issn-header .issn-item {
	font-weight: bold;
}
@media only screen and (max-width: 992px) {
	.container > * {
		margin: 0 10px;
	}
	.main {
		padding: 0;
	}
	.series {
		row-gap: 20px;
		column-gap: 0;
	}
}
@media only screen and (max-width: 768px) {
	.series {
		grid-template-columns: 1fr 1fr;
		column-gap: 0;
	}
	.series div:last-child {
		grid-column-start: 1;
		grid-column-end: 3;
		margin: auto;
		width: 50%;
	}
}
@media only screen and (max-width: 567px) {
	.series {
		grid-template-columns: 250px;
		width: min-content;
		margin: auto;
	}
	.series div:last-child {
		grid-column-end: unset;
		width: unset;
	}
}
@media only screen and (min-width: 1400px) {
	.main {
		max-width: 1400px;
		margin: 0 auto !important;
	}
}
</style>
<style>
.vision *,
.found * {
	white-space: pre-line !important;
	font-family: changeMedium !important;
}
</style>
